import React, { useState, useEffect } from "react";
import Chart, {
  CommonSeriesSettings,
  Series,
  ArgumentAxis,
  ValueAxis,
  Grid,
  Legend,
  Point,
  Font,
  Title,
  Tooltip,
} from "devextreme-react/chart";
import { CustomBreadcrumbs as Breadcrumbs } from "../../components";
import API from "../../api/api";
import { parsedUser } from "../../utils/GetCurrentUser";
import "../../pages/DashboardGeneral/DashboardGeneral.css";
// import { useToast } from "../../contexts/toast";




const DashboardGeneral = () => {
  const user = parsedUser();
//   const toast = useToast();

  const [gridConfig, setGridConfig] = useState(null);
  const [allCards, setAllCards] = useState([]);
  const [indiceRotacionConfig, setIndiceRotacionConfig] = useState(null);
  const [entradasConfig, setEntradasConfig] = useState(null);
  const [salidasConfig, setSalidasConfig] = useState(null);
  const [inspeccionesConfig, setInspeccionesConfig] = useState(null);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const getDataDashboard = async () => {
    try {
      const query = `Token=${user.Token}&IdUser=${user.IdUser}`;
      const response = await API.getAction(
        `api/OcupacionProcesos/DashboardOcupacionGeneral?${query}`,
        null
      );

      if (response.data && response.data.length > 0) {
        let firstLevel = JSON.parse(response.data[0].JSONData);
        const dashboardData = firstLevel.DashboardData;

        // =============== GRID CONFIG ===============
        if (dashboardData.Grid) {
          setGridConfig(dashboardData.Grid);
        }

        // ======== ITEMS ===========
        if (dashboardData.Items && dashboardData.Items.length > 0) {
          dashboardData.Items.forEach((item) => {
            // ===== CARDS =====
            if (item.ItemType === "Card" && item.ItemData) {
              setAllCards(
                item.ItemData.map((cardItem) => ({
                  title: cardItem.Kpi,
                  value: cardItem.Valor,
                  icon: cardItem.Icon,
                  headerColor: cardItem.ForeColor,
                  iconColor: cardItem.ForeColor,
                  bgColor: cardItem.BackColor,
                  width: cardItem.Width,
                  height: cardItem.Height,
                  gridRow: item.GridRow,
                  gridCol: item.GridCol,
                }))
              );
            }

            // ===== GRÁFICOS =====
            if (item.ItemData && item.ItemData.length > 0) {
              const itemData = item.ItemData[0];
              const config = {
                title: item.ItemTitle,
                type: item.ItemType,
                series: itemData.Series,
                data: itemData.Data,
                gridRow: item.GridRow,
                gridCol: item.GridCol,
              };

              switch (item.ItemIndex) {
                case 2:
                  setIndiceRotacionConfig(config);
                  break;
                case 3:
                  setEntradasConfig(config);
                  break;
                case 4:
                  setSalidasConfig(config);
                  break;
                case 5:
                  setInspeccionesConfig(config);
                  break;
                default:
                  break;
              }
            }
          });
        }
      }
    } catch (error) {
      console.error("❌ Dashboard Error:", error);
    } finally {
        setIsRefreshing(false);
    }
  };

  useEffect(() => {
    if (user && user.Token) {
      getDataDashboard();
    }

    // Lógica para expandir el content al 100%
    const contentElement = document.querySelector('.content');
    if (contentElement) {
      contentElement.classList.add('dashboard-full-width');
    }

    // Cleanup: eliminar la clase al salir de la pantalla
    return () => {
      if (contentElement) {
        contentElement.classList.remove('dashboard-full-width');
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ---------------------------------------------------
  // FUNCIONES PARA RENDERIZAR CADA GRÁFICO
  // ---------------------------------------------------

  const renderIndiceRotacion = () => {
    if (!indiceRotacionConfig) return null;

    const { title, series, data } = indiceRotacionConfig;


    return (
      <div 
        className="bg-white p-4 shadow" 
        style={{ 
            borderRadius: 15, 
            height: "100%", 
            width: "50%" 
        }}>
        <Chart 
            dataSource={data} 
            style={{ height: "100%" }}>
          <CommonSeriesSettings 
            argumentField="Periodo" 
            type="spline">
            <Point 
                hoverMode="allArgumentPoints" />
          </CommonSeriesSettings>

          {series.map((s, idx) => (
            <Series
              key={idx}
              valueField={s.Serie}
              name={s.Kpi}
              color={s.Color}
              axis={s.Group === 2 ? "secondary" : "primary"}
            />
          ))}

          <ArgumentAxis>
            <Grid visible={true} />
          </ArgumentAxis>

          <ValueAxis name="primary">
            <Grid visible={true} />
          </ValueAxis>

          <ValueAxis name="secondary" position="right">
            <Grid visible={false} />
          </ValueAxis>

            <Title 
                text={title} 
                horizontalAlignment="center" 
            >
                <Font 
                    size={16} 
                    weight={600} 
                />
            </Title>

          <Legend 
            verticalAlignment="bottom" 
            horizontalAlignment="center" />

          <Tooltip enabled={true} />
        </Chart>
      </div>
    );
  };

  const renderEntradas = () => {
    if (!entradasConfig) return null;

    const { title, series, data } = entradasConfig;

    return (
      <div 
        className="bg-white p-4 shadow" 
        style={{ 
        borderRadius: 15, 
        height: "100%",
        width: "50%" }}>
        <Chart dataSource={data} style={{ height: "100%" }}>
          <CommonSeriesSettings argumentField="Periodo" type="stackedBar" />

          {series.map((s, idx) => (
            <Series key={idx} valueField={s.Serie} name={s.Kpi} color={s.Color} stack="total" />
          ))}

          <ArgumentAxis>
            <Grid visible={false} />
          </ArgumentAxis>

          <ValueAxis>
            <Grid visible={true} />
          </ValueAxis>

          <Title text={title}
            horizontalAlignment="center">
                <Font 
                    size={16} 
                    weight={600} />
          </Title>

          <Legend verticalAlignment="bottom" horizontalAlignment="center" />
          <Tooltip enabled={true} />
        </Chart>
      </div>
    );
  };

  const renderSalidas = () => {
    if (!salidasConfig) return null;

    const { title, series, data } = salidasConfig;

    return (
      <div 
        className="bg-white p-4 shadow" 
        style={{ 
            borderRadius: 15, 
            height: "100%",
            width: "50%"  
            }}>
        <Chart 
            dataSource={data} 
            style={{ 
                height: "100%" 
            }}>
          <CommonSeriesSettings argumentField="Periodo" type="stackedBar" />

          {series.map((s, idx) => (
            <Series 
                key={idx} 
                valueField={s.Serie} 
                name={s.Kpi} 
                color={s.Color} 
                stack="total" />
          ))}

          <ValueAxis>
            <Grid visible={true} />
          </ValueAxis>

          <ArgumentAxis>
            <Grid visible={false} />
          </ArgumentAxis>

          <Title 
            text={title}
            horizontalAlignment="center">
            <Font 
                size={16} 
                weight={600} />
          </Title>

          <Legend verticalAlignment="bottom" horizontalAlignment="center" />
          <Tooltip enabled={true} />
        </Chart>
      </div>
    );
  };

  const renderInspecciones = () => {
    if (!inspeccionesConfig) return null;

    const { title, series, data } = inspeccionesConfig;

    return (
      <div 
        className="bg-white p-4 shadow" 
        style={{ 
            borderRadius: 15,
            height: "100%", 
            width: "50%" 
            }}>
        <Chart 
            dataSource={data} 
            style={{ 
                height: "100%" 
            }}>
          <CommonSeriesSettings argumentField="Periodo" type="bar" />

          {series.map((s, idx) => (
            <Series key={idx} valueField={s.Serie} name={s.Kpi} color={s.Color} />
          ))}

          <ArgumentAxis>
            <Grid visible={false} />
          </ArgumentAxis>

          <ValueAxis>
            <Grid visible={true} />
          </ValueAxis>

          <Title 
            text={title}
            horizontalAlignment="center">
            <Font 
                size={16} 
                weight={600} />
          </Title>

          <Legend verticalAlignment="bottom" horizontalAlignment="center" />
          <Tooltip enabled={true} />
        </Chart>
      </div>
    );
  };


  return (
    <>
      <Breadcrumbs pathTitle={"Dashboard General"} />

      {/* BOTÓN DE ACTUALIZAR */}
    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '15px', paddingRight: '20px' }}>
      <button
        onClick={getDataDashboard}
        disabled={isRefreshing}
        style={{
          padding: '10px 20px',
          backgroundColor: isRefreshing ? '#cccccc' : '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: isRefreshing ? 'not-allowed' : 'pointer',
          fontSize: '14px',
          fontWeight: '500',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}
      >
        <i className={`fas fa-sync-alt ${isRefreshing ? 'fa-spin' : ''}`}></i>
        {isRefreshing ? 'Actualizando...' : 'Actualizar Datos'}
      </button>
    </div>

      {/* CONTENEDOR DE CARDS */}
      {allCards.length > 0 && (
        <div className="cards-container">
          {allCards.map((card, index) => (
            <div
              key={`card-${index}`}
              className="general-card-item"
              style={{ width: card.width, height: card.height }}
            >
              <div className="general-stat-card" style={{ backgroundColor: card.bgColor }}>
                <div
                  className="general-card-header"
                  style={{ backgroundColor: card.headerColor, color: card.bgColor }}
                >
                  {card.title}
                </div>

                <div className="general-card-body">
                  <div className="general-card-icon" style={{ color: card.iconColor }}>
                    <i className={card.icon}></i>
                  </div>

                  <div className="general-card-value" style={{ color: card.headerColor }}>
                    {card.value}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {gridConfig && (
        <div
          className="dashboard-grid-container"
          style={{
            gridTemplateRows: gridConfig.Rows,
            gridTemplateColumns: gridConfig.Cols,
            gap: gridConfig.Gap,
            padding: gridConfig.Padding,
            height: gridConfig.height,
          }}
        >

        {/* GRÁFICOS */}
        {[
          // GRÁFICO ÍNDICE DE ROTACIÓN
          indiceRotacionConfig && {
            itemIndex: "rotacion",
            gridRow: indiceRotacionConfig.gridRow,
            gridCol: indiceRotacionConfig.gridCol,
            render: () => renderIndiceRotacion(),
          },

          // GRÁFICO ENTRADAS
          entradasConfig && {
            itemIndex: "entradas",
            gridRow: entradasConfig.gridRow,
            gridCol: entradasConfig.gridCol,
            render: () => renderEntradas(),
          },

          // GRÁFICO SALIDAS
          salidasConfig && {
            itemIndex: "salidas",
            gridRow: salidasConfig.gridRow,
            gridCol: salidasConfig.gridCol,
            render: () => renderSalidas(),
          },

          // GRÁFICO INSPECCIONES
          inspeccionesConfig && {
            itemIndex: "inspecciones",
            gridRow: inspeccionesConfig.gridRow,
            gridCol: inspeccionesConfig.gridCol,
            render: () => renderInspecciones(),
          },
        ]
          .filter(Boolean) 
          .map((item) => (
            <div
              key={item.itemIndex}
              style={{
                gridRow: item.gridRow,
                gridColumn: item.gridCol,
              }}
            >
              {item.render()}
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default DashboardGeneral;
